import {WeekoffsList} from "./WeekoffsList";
import {WeekoffsEdit} from "./WeekoffsEdit";
import {WeekoffsCreate} from "./WeekoffsCreate";

export default {
    list: WeekoffsList,
    create: WeekoffsCreate,
    edit: WeekoffsEdit
};
